"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var context_1 = require("../../context/context");
var hooks_1 = require("../../hooks");
var SmallLabel_1 = __importDefault(require("./SmallLabel"));
function Balance(_a) {
    var isLoading = _a.isLoading, value = _a.value, _b = _a.className, className = _b === void 0 ? "" : _b, label = _a.label, suffix = _a.suffix, hideLabel = _a.hideLabel, emptyUi = _a.emptyUi, decimalScale = _a.decimalScale;
    var _c = (0, context_1.useTwapContext)(), translations = _c.translations, uiPreferences = _c.uiPreferences;
    var _emptyUi = emptyUi || uiPreferences.balanceEmptyUI;
    var args = { value: value, suffix: suffix ? " ".concat(suffix) : undefined };
    var formattedValue = (0, hooks_1.useFormatNumberV2)(__assign(__assign({}, args), { decimalScale: decimalScale }));
    if (value == null) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(StyledLabel, __assign({ loading: isLoading, className: "twap-balance ".concat(className) }, { children: [hideLabel ? null : label ? (0, jsx_runtime_1.jsx)("span", __assign({ className: "twap-balance-title" }, { children: label })) : (0, jsx_runtime_1.jsxs)("span", __assign({ className: "twap-balance-title" }, { children: [translations.balance, ":"] })), " ", !value && _emptyUi ? _emptyUi : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: formattedValue })] })));
}
exports.default = Balance;
var StyledLabel = (0, styled_components_1.styled)(SmallLabel_1.default)({
    overflow: "hidden",
    minWidth: 0,
});
